import { $playerProfile } from '../../../../backend/store';
import Selector from '../selector/Selector';
import BG from './bg/BG';
import Alice from './upgrades/alice/Alice';
import Bob from './upgrades/bob/Bob';

const WIDTH = 720;
const HEIGHT = 300;

export default class Footer extends Phaser.GameObjects.Container {
    private alice!: Alice;
    private bob!: Bob;
    private bg!: BG;

    constructor(scene: Phaser.Scene) {
        let x = 0;
        let y = scene.cameras.main.height - HEIGHT;
        super(scene, x, y);

        this.setupBG();
        this.setupUpgrades();
        this.setupListeners();

        // this.setVisible(false);
    }

    static get HEIGHT() {
        return HEIGHT;
    }

    setupBG() {
        this.bg = new BG(this.scene, 0, 0);
        this.add(this.bg);
    }

    setupUpgrades() {
        // let x = (this.scene.cameras.main.width - WIDTH) / 2;
        let x = 0;
        let y = 0;

        this.alice = new Alice(this.scene, x, y);
        this.add(this.alice);

        this.bob = new Bob(this.scene, x, y);
        this.add(this.bob);
    }

    setupListeners() {
        this.scene.events.on(Selector.EVENTS.HERO_SELECTED, this.onHeroSelected, this);
        // $playerProfile.watch((next) => {
        //     console.log(next.current_chapter);
        // });
    }

    onHeroSelected(heroId: number) {
        if (heroId === 0) {
            this.alice.show();
            this.bob.hide();
        } else {
            this.alice.hide();
            this.bob.show();
        }
    }

    destroy() {
        this.scene.events.off(Selector.EVENTS.HERO_SELECTED, this.onHeroSelected, this);
        super.destroy();
    }
}
